import { render, staticRenderFns } from "./LaboratorioComponente.vue?vue&type=template&id=ecdcf374&scoped=true"
import script from "./LaboratorioComponente.vue?vue&type=script&lang=js"
export * from "./LaboratorioComponente.vue?vue&type=script&lang=js"
import style0 from "./LaboratorioComponente.vue?vue&type=style&index=0&id=ecdcf374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdcf374",
  null
  
)

export default component.exports